export default __webpack_public_path__ + "static/media/svg-11.d8769896.svg";